// Section copy: Editable via SiteSettings API. See CMS-CONTENT-PLAN.md item #9.
import { useEffect, useState } from "react";
import { Box, Button, Container, Heading, Link, Stack, Text } from "@chakra-ui/react";
import { Link as ReactLink } from "react-router-dom";
import { useCmsApi } from "../../services/useCmsApi";

export const InlineContactSection = (): JSX.Element => {
	const cmsApi = useCmsApi();
	const [contactEmail, setContactEmail] = useState("info@geco-ag.com");

	useEffect(() => {
		cmsApi.getSiteSetting("contactEmail").then((s) => { if (s?.value) setContactEmail(s.value); });
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Box
			bgImage="url('contact-background-field.png')"
			bgSize="cover"
			bgPosition="center"
			position="relative"
			color="white"
			py={{ base: "12", md: "16" }}
		>
			<Box position="absolute" inset={0} bg="blue.900" opacity={0.74} />
			<Container maxW="1480px">
				<Stack
					position="relative"
					direction={{ base: "column", md: "row" }}
					justify="space-between"
					align="center"
					spacing="6"
				>
					<Stack spacing="2">
						<Heading size={{ base: "sm", md: "lg" }}>Drop us a line for more information</Heading>
						<Text opacity={0.9}>
							Reach us at{" "}
							<Link
								href={`mailto:${contactEmail}`}
								color="blue.200"
								fontWeight="semibold"
							>
								{contactEmail}
							</Link>
						</Text>
					</Stack>
					<Link as={ReactLink} to="/contact-us" flexShrink={0}>
						<Button
							size="lg"
							bg="white"
							color="blue.700"
							_hover={{ bg: "blue.50" }}
							fontWeight="bold"
						>
							Contact Us
						</Button>
					</Link>
				</Stack>
			</Container>
		</Box>
	);
};
